
    <mat-card>
        <mat-card-content class="calendario-content">
            <mat-grid-list cols="4" rowHeight="60px">
                <mat-grid-tile class="start">
                    <button mat-stroked-button color="primary" (click)="today()"><mat-icon>today</mat-icon>HOY</button>
                </mat-grid-tile>
                <mat-grid-tile>
                    <button mat-stroked-button color="primary" disabled>{{ tituloHoy() | uppercase }}</button>
                </mat-grid-tile>
                <mat-grid-tile>
                    <button mat-stroked-button color="primary" (click)="back()"><mat-icon class="no-margin icon-size-25">skip_previous</mat-icon></button>
                    <button mat-stroked-button color="primary" (click)="next()"><mat-icon class="no-margin icon-size-25">skip_next</mat-icon></button>
                </mat-grid-tile>
                <mat-grid-tile class="end">
                    <button mat-mini-fab color="primary" (click)="cargaForzada()"><mat-icon>cached</mat-icon></button>&nbsp;
                    <button mat-mini-fab color="primary" (click)="picker.open()"><mat-icon>date_range</mat-icon></button>
                    <mat-form-field class="inputDatePicker">
                        <input matInput [matDatepicker]="picker" (dateInput)="changeDatePicker($event)" [value]="FechaHoy">
                        <mat-datepicker #picker></mat-datepicker>
                    </mat-form-field>
                </mat-grid-tile>
            </mat-grid-list>
            <full-calendar #calendar [options]='calendarOptions()'>
                <!-- <ng-template #eventContent let-arg>
                    <span>{{ arg.event.title }}</span>
                    <a rel="stylesheet" (click)="openWindow($event, arg.event)">
                        <mat-icon class="icon-open-new-window">open_in_new</mat-icon>
                    </a>
                </ng-template> -->
            </full-calendar>
            <div class="button-add">
                <a mat-fab color="warn" routerLink="/entrada/new/add">
                    <mat-icon>add</mat-icon>
                </a>
            </div>
        </mat-card-content>
    </mat-card>
